import React from 'react';

const FilterIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
    >
      <g clip-path='url(#clip0_17_1847)'>
        <path
          d='M4 18.4H8C8.55 18.4 9 17.95 9 17.4C9 16.85 8.55 16.4 8 16.4H4C3.45 16.4 3 16.85 3 17.4C3 17.95 3.45 18.4 4 18.4ZM3 7.39999C3 7.94999 3.45 8.39999 4 8.39999H20C20.55 8.39999 21 7.94999 21 7.39999C21 6.84999 20.55 6.39999 20 6.39999H4C3.45 6.39999 3 6.84999 3 7.39999ZM4 13.4H14C14.55 13.4 15 12.95 15 12.4C15 11.85 14.55 11.4 14 11.4H4C3.45 11.4 3 11.85 3 12.4C3 12.95 3.45 13.4 4 13.4Z'
          fill='#1A1C2C'
        />
      </g>
      <defs>
        <clipPath id='clip0_17_1847'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0 0.399994)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FilterIcon;
